// extracted by mini-css-extract-plugin
module.exports = {"heroGraphic":"contact-module--heroGraphic--17NR4"};